module.exports = __webpack_public_path__ + "img/poster.95c9f751.png";